import CustomTable from '../../../../elements/Table/CustomTable'
import React, {Component, Fragment} from 'react'

class Preview extends Component {
  render() {
    const {list, columns, desiredColumns} = this.props
    const newColumnsList = columns.filter(c =>
      desiredColumns.includes(c.accessor),
    )
    return (
      <Fragment>
        <CustomTable
          hide={{refresh: true}}
          data={list}
          columns={newColumnsList}
        />
      </Fragment>
    )
  }
}

export default Preview
